const d =
	'M702-96 430-369q-21 9-41 12t-46 3q-107 0-180.5-74T89-607q0-32 10.5-67t25.5-63l149 150 94-88-153-153q26-14 61.5-26t66.5-12q108 0 183 75.5T601-607q0 23-3 44.5T586-519l273 271q19 20 19 43t-19 41l-74 68q-17 17-41.5 17T702-96Z';

export default d;
